export default __webpack_public_path__ + "static/media/ETH.2cb05cd4.svg";